export const peopleRoutes = {
  create: [],
  view: [
    {
      path: 'people',
      title: `people`,
      loadComponent: () =>
        import('./pages/people-section/people-section.page').then((m) => m.PeopleSectionPage),
    },
  ],
};
